// @ts-nocheck
import * as React from 'react';
import gandyLogo from '../../img/gandy_logo.svg';
import { Link } from 'react-router-dom';
import SlidingText from '../../ui_components/sliding_text/sliding_text';
import { LoaderCircle } from 'lucide-react';

export function LoadingScreen() {
    const texts = [
        "sensing if you're worthy to enter...",
        'casting spell to unlock the entrance...',
        'opening magic doors...',
        'lightning up all the lamps...',
        'chasing away the spiders...',
        'looking for your knowledge...',
        'Ha, got it! Come in... there is much to be shared...',
    ];

    return (
        <div className="w-dvw h-dvh flex flex-col items-center justify-center">
            <Link className={'logo-link'} to={`/`}>
                <figure className="flex flex-col items-center justify-center">
                    <img
                        className={'h-[120px]'}
                        src={gandyLogo}
                        height="60"
                        alt="Gandy Administration Panel"
                    />
                    <h1 className={'font-semibold leading-none tracking-tight'}>
                        Gandy.ai
                    </h1>
                </figure>
            </Link>
            <br />
            <br />
            <LoaderCircle className={'animate-spin'} size={64} />
            <br />
            <br />
            <SlidingText texts={texts} interval={2500} />
        </div>
    );
}
